import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';

import { Observable, Subject, ReplaySubject } from 'rxjs';


import { UserInfoService, LoginInfoInStorage } from './user-info.service';
import { ApiRequestService } from './api-request.service';
import { CriteriaIO , SearchCriteriaDO} from './../../shared/models';



@Injectable()
export class VehicleService {
    constructor(
        private http: Http,
        private apiRequest: ApiRequestService
    ) { }

    getvehicleModel(vehicleMake: String): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();

        //params.set('id', typeof id === "number"? id.toString():"0");

        let caseDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want

        this.apiRequest.get('vehicleMakeModel/fetchModelsByMakeCd/' + vehicleMake)
            .subscribe(jsonResp => {

                let returnObj = jsonResp;
                caseDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return caseDataSubject;
    }
    getvehicleVariant(vehicleModel: String): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();

        //params.set('id', typeof id === "number"? id.toString():"0");

        let caseDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want

        this.apiRequest.get('vehicleMakeModel/fetchVariantsByModelCd/' + vehicleModel)
            .subscribe(jsonResp => {

                let returnObj = jsonResp;
                caseDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return caseDataSubject;
    }
    getAllMotorProduct(planTypeCd: String, productFamilyCd: String): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();
        let submissionMode = "PORTAL"

        //params.set('id', typeof id === "number"? id.toString():"0");

        let caseDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want

        this.apiRequest.get('api/product/fetchByPlantypeAndProductFamily/' + planTypeCd + "/" + productFamilyCd + "/" + submissionMode)
            .subscribe(jsonResp => {

                let returnObj = jsonResp;
                caseDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return caseDataSubject;
    }

    getAllTravelProduct(LOB, productTypeCd, tripTypeCd, currencyCd): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();
        let submissionMode: any;
        submissionMode = "PORTAL";
        // LOB = LOB === null ? "" : LOB;
        // productTypeCd = productTypeCd === null ? "" : productTypeCd;
        // tripTypeCd = tripTypeCd === null ? "" : tripTypeCd;
        // currencyCd = currencyCd === null ? "" : currencyCd;

        // let criteriaArray = [];
        // criteriaArray.push(submissionMode);
        // criteriaArray.push(LOB);
        // criteriaArray.push(productTypeCd);
        // criteriaArray.push(tripTypeCd);
        // criteriaArray.push(currencyCd);
        // criteriaArray.push('');
        let criteria: CriteriaIO[] = [];
        var criteriaObj = new CriteriaIO();
        // criteriaObj.setParamName("criteria");
        // criteriaObj.setParamValue(criteriaParam);
        // criteria.push(criteriaObj);

        let searchCriteriaList: SearchCriteriaDO[] = [];

        var searchCriteriaDO1 = new SearchCriteriaDO();
        searchCriteriaDO1.setParamName("submissionMode");
        searchCriteriaDO1.setParamValue(submissionMode);
        searchCriteriaList.push(searchCriteriaDO1);

        var searchCriteriaDO2 = new SearchCriteriaDO();
        searchCriteriaDO2.setParamName("lob");
        searchCriteriaDO2.setParamValue(LOB);
        searchCriteriaList.push(searchCriteriaDO2);

        var searchCriteriaDO3 = new SearchCriteriaDO();
        searchCriteriaDO3.setParamName("productTypeCd");
        searchCriteriaDO3.setParamValue(productTypeCd);
        searchCriteriaList.push(searchCriteriaDO3);

        var searchCriteriaDO4 = new SearchCriteriaDO();
        searchCriteriaDO4.setParamName("tripTypeCd");
        searchCriteriaDO4.setParamValue(tripTypeCd);
        searchCriteriaList.push(searchCriteriaDO4);

        var searchCriteriaDO5 = new SearchCriteriaDO();
        searchCriteriaDO5.setParamName("currencyCd");
        searchCriteriaDO5.setParamValue(currencyCd);
        searchCriteriaList.push(searchCriteriaDO5);

        criteriaObj.setSearchCriteriaList(searchCriteriaList);

        //params.set('id', typeof id === "number"? id.toString():"0");

        let caseDataSubject: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want

        this.apiRequest.post('api/product/filterTravelProducts/', criteriaObj)
            .subscribe(jsonResp => {

                let returnObj = jsonResp;
                caseDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return caseDataSubject;
    }
    getPromoCodeDiscount(promoCode: String) {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();
        let submissionMode = "PORTAL"
        let caseDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want
        this.apiRequest.get('api/promotion/fetchByPromoCodePortal/' + promoCode)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                caseDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });
        return caseDataSubject;
    }
    getProductCoverage(productCd: String): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();

        //params.set('id', typeof id === "number"? id.toString():"0");

        let caseDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want

        let pathVariables = [];
        pathVariables.push(productCd);
        this.apiRequest.getCallWithAPIMapper('fetchRiders', null, null, pathVariables)
        // this.apiRequest.getCallWithAPIMapper('fetchRiders' + productCd)
            .subscribe(jsonResp => {

                let returnObj = jsonResp;
                caseDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return caseDataSubject;
    }

    getvehicleSeatingCapacity(modelCd, variantCd): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();

        //params.set('id', typeof id === "number"? id.toString():"0");
        // let criteriaParam = [];
        // criteriaParam.push(modelCd);
        // criteriaParam.push(variantCd);

        let criteria: CriteriaIO[] = [];
        var criteriaObj = new CriteriaIO();
        // criteriaObj.setParamName("criteria");
        // criteriaObj.setParamValue(criteriaParam);
        // criteria.push(criteriaObj);

        let searchCriteriaList: SearchCriteriaDO[] = [];

        var searchCriteriaDO1 = new SearchCriteriaDO();
        searchCriteriaDO1.setParamName("modelCd");
        searchCriteriaDO1.setParamValue(modelCd);
        searchCriteriaList.push(searchCriteriaDO1);

        var searchCriteriaDO2 = new SearchCriteriaDO();
        searchCriteriaDO2.setParamName("variantCd");
        searchCriteriaDO2.setParamValue(variantCd);
        searchCriteriaList.push(searchCriteriaDO2);

        criteriaObj.setSearchCriteriaList(searchCriteriaList);

        let caseDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want

        // this.apiRequest.get('vehicleMakeModel/fetchVariantByVariantCd/' + variantCd)
        this.apiRequest.post('vehicleMakeModel/fetchVariantByModelCDAndVariantCd', criteriaObj)
            .subscribe(jsonResp => {

                let returnObj = jsonResp;
                caseDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return caseDataSubject;
    }
    // getvehicleSeatingCapacity(vehicleKey: String): Observable<any> {
    //     let me = this;
    //     let params: URLSearchParams = new URLSearchParams();

    //     //params.set('id', typeof id === "number"? id.toString():"0");

    //     let caseDataSubject = new Subject<any>(); // Will use this subject to emit data that we want

    //     this.apiRequest.get('vehicleMakeModel/fetchVariantsByVehicleKey/' + vehicleKey)
    //         .subscribe(jsonResp => {

    //             let returnObj = jsonResp;
    //             caseDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
    //         });

    //     return caseDataSubject;
    // }
    getProductByProductCd(productCd: String): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();

        //params.set('id', typeof id === "number"? id.toString():"0");

        let caseDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1);// Will use this subject to emit data that we want

        this.apiRequest.get('api/product/fetchProductByProductCd/' + productCd)
            .subscribe(jsonResp => {

                let returnObj = jsonResp;
                caseDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
                caseDataSubject.complete();
            });

        return caseDataSubject;
    }
    getProductAttributeValues(attributeCd: String, baseProductCd: String): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();

        let caseDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1);
        this.apiRequest.get('api/product/getProductAttribute/' + attributeCd + "/" + baseProductCd)
            // this.apiRequest.get('api/product/getProductAttributeResponse/' + attributeCd + "/" + baseProductCd)
            .subscribe(jsonResp => {

                let returnObj = jsonResp;
                caseDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return caseDataSubject;
    }

    getProductAttributeValueBatch1(attributeCd: String, baseProductCd: String): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();

        let productAttributeDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1);
        let DataList: any[] = [];
        //this.apiRequest.get('api/product/getProductAttribute/' + attributeCd + "/" + baseProductCd)
        this.apiRequest.get('api/product/getProductAttributeResponse/' + attributeCd + "/" + baseProductCd)
            .subscribe(jsonResp => {
                productAttributeDataSubject.next(jsonResp); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return productAttributeDataSubject;
    }

    getProductAttributeValueBatch(attributeCd, baseProductCd): Observable<any> {
        let lookupDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1);
        let lookupServiceData: any = {};
        let lookupDataList: any[] = [];
        let lookupServiceURL = 'api/product/getProductAttributeResponse/' + attributeCd + "/" + baseProductCd;
        this.apiRequest.get(lookupServiceURL)
            .subscribe(jsonResp => {

                // for (var i = 0; i < jsonResp.length; i++) {
                //     lookupDataList.push(jsonResp[i]);
                // }

                lookupDataSubject.next(jsonResp);
                lookupDataSubject.complete();

            })

        return lookupDataSubject;
    }

    getVehiclePriceService(modelCd, variantCd, year) {

        let me = this;
        let params: URLSearchParams = new URLSearchParams();

        // let criteriaParam = [];
        // criteriaParam.push(modelCd);
        // criteriaParam.push(variantCd);
        // criteriaParam.push(year);

        let criteria: CriteriaIO[] = [];
        var criteriaObj = new CriteriaIO();
        // criteriaObj.setParamName("criteria");
        // criteriaObj.setParamValue(criteriaParam);
        // criteria.push(criteriaObj);
        let searchCriteriaList: SearchCriteriaDO[] = [];

        var searchCriteriaDO1 = new SearchCriteriaDO();
        searchCriteriaDO1.setParamName("modelCd");
        searchCriteriaDO1.setParamValue(modelCd);
        searchCriteriaList.push(searchCriteriaDO1);

        var searchCriteriaDO2 = new SearchCriteriaDO();
        searchCriteriaDO2.setParamName("variantCd");
        searchCriteriaDO2.setParamValue(variantCd);
        searchCriteriaList.push(searchCriteriaDO2);

        var searchCriteriaDO3 = new SearchCriteriaDO();
        searchCriteriaDO3.setParamName("manufacturingYear");
        searchCriteriaDO3.setParamValue(year);
        searchCriteriaList.push(searchCriteriaDO3);

        criteriaObj.setSearchCriteriaList(searchCriteriaList);

        let productCurrencies: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want after ajax search policy attempt
        let searchURL = 'vehicleMakeModel/fetchVariantPrice';

        this.apiRequest.post(searchURL, criteriaObj)
            .subscribe(jsonResp => {
                console.log(jsonResp)
                productCurrencies.next(jsonResp); // incidentList is a Subject and emits an event thats being listened to by the components
            });
        return productCurrencies;
    }

    getLOBBasedProducts(productFamilyCd: Array<String>): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();

        let caseDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want

        this.apiRequest.post('api/product/fetchProductByLOB', productFamilyCd)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                caseDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return caseDataSubject;
    }

}
